<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="'待审核('+unAuditCount+')'" name="first">
          <single-one v-if="activeName == 'first'" :tabCurrent="0"></single-one>
        </el-tab-pane>
        <el-tab-pane label="已通过" name="second">
          <single-one v-if="activeName == 'second'" :tabCurrent="1"></single-one>
        </el-tab-pane>
        <el-tab-pane label="驳回" name="third">
          <single-one v-if="activeName == 'third'" :tabCurrent="2"></single-one>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { queryUserCommissionWithdrawalApplyLogCount } from '@/api/finance'
import SingleOne from './components/SingleOne.vue'
export default {
  name: 'Finance',
  components: {
    SingleOne
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      activeName:'first',
      unAuditCount:0
    }
  },
  mounted () {
    this.detailInfoFun();
  },
  methods: {
    detailInfoFun(){
      var that = this;
      queryUserCommissionWithdrawalApplyLogCount({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.unAuditCount = data.unAuditCount;
        }
      })
    },
    handleClick(tab){

    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/Finance.vue